import React, { useCallback, useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { makeStyles } from 'tss-react/mui';
import Icon from '../../../base/icons/components/Icon';
import { IconMessage } from '../../../base/icons/svg';
import { isLocalParticipantModerator } from '../../../base/participants';
import PollItem from './PollItem';
const useStyles = makeStyles()(() => {
    return {
        container: {
            height: '100%',
            width: '100%',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            flexDirection: 'column'
        },
        emptyIcon: {
            width: '100px',
            padding: '16px',
            '& svg': {
                width: '100%',
                height: 'auto'
            }
        },
        emptyMessage: {
            color: '#C2C2C2',
            padding: '0 24px',
            textAlign: 'center'
        }
    };
});
const PollsList = ({ sourceFilter }) => {
    const { t } = useTranslation();
    const { classes } = useStyles();
    const allPolls = useSelector((state) => { var _a; return ((_a = state['features/polls']) === null || _a === void 0 ? void 0 : _a.polls) || {}; });
    const pollListEndRef = useRef(null);
    const isModerator = useSelector((state) => isLocalParticipantModerator(state));
    // Filter polls by origin when a sourceFilter is specified.
    // undefined / missing senderSource is treated as 'main' (legacy payloads).
    const polls = sourceFilter
        ? Object.fromEntries(Object.entries(allPolls).filter(([, poll]) => {
            var _a;
            const src = (_a = poll.senderSource) !== null && _a !== void 0 ? _a : 'main';
            return src === sourceFilter;
        }))
        : allPolls;
    const scrollToBottom = useCallback(() => {
        if (pollListEndRef.current) {
            // Safari does not support options
            const param = {
                behavior: 'smooth',
                block: 'end',
                inline: 'nearest'
            };
            pollListEndRef.current.scrollIntoView(param);
        }
    }, [pollListEndRef.current]);
    useEffect(() => {
        scrollToBottom();
    }, [polls, scrollToBottom]);
    const listPolls = Object.keys(polls);
    return (React.createElement(React.Fragment, null, listPolls.length === 0 ? (React.createElement("div", { className: classes.container },
        React.createElement(Icon, { className: classes.emptyIcon, color: '#858585', src: IconMessage }),
        React.createElement("span", { className: classes.emptyMessage }, isModerator ? t('polls.results.empty') : t('polls.results.guestempty')))) : listPolls.map((id, index) => (React.createElement(PollItem, { key: id, pollId: id, ref: listPolls.length - 1 === index
            ? pollListEndRef
            : null })))));
};
export default PollsList;
